import React from "react"
import { Button } from "@ridecell/web-components-material"
import CircularProgress from "@material-ui/core/CircularProgress"
import { makeStyles } from "@material-ui/core/styles"

const useStyles = makeStyles((theme) => ({
  buttonProgress: {
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
  wrapper: {
    width: "95%",
    margin: theme.spacing(1),
    position: "relative",
  },
}))
const LoadingButton = ({
  dataTestId,
  disabled,
  loading,
  text,
  onClick,
  props
}) => {
  const classes = useStyles()
  return (
    <div className={classes.wrapper}>
      <Button
        color="primary"
        dataTestId={dataTestId}
        disabled={disabled || loading}
        onClick={onClick}
        type="submit"
        variant="contained"
        {...props}
      >
        {text}
      </Button>
      {loading && (
        <CircularProgress size={24} className={classes.buttonProgress} />
      )}
    </div>
  )
}

export default LoadingButton
